import { IdScanDataDefaults } from '../configuration/DataStoreDefaults';
import { DataStore } from '../../helpers/classes/DataStore';
import { IDataStoreFormat } from '../../helpers/interfaces/DataFormats';
import { IIdScanData } from '../interfaces/DataFormats';

export enum DataStoreType {
	ID_SCAN = 'ID_SCAN',
}

export class DataService {

	private _dataStores: Partial<Record<DataStoreType, DataStore>> = {};

	public getDataStore = <T extends IDataStoreFormat>(type: DataStoreType): DataStore<T> => {
		if (this._dataStores[type] instanceof DataStore) {
			return this._dataStores[type] as DataStore<T>;
		} else {
			switch (type) {
				case DataStoreType.ID_SCAN:
					return (this._dataStores[type] = new DataStore<IIdScanData>(IdScanDataDefaults)) as any as DataStore<T>;

				default:
					throw new Error('Unsupported DataStore type');
			}
		}
	}

	public deleteDataStore = (type: DataStoreType): void => {
		if (this._dataStores[type] instanceof DataStore) {
			this._dataStores[type]!.removeAllListeners();
			delete this._dataStores[type];
		}
	}

}

export default new DataService();
